import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getBrandsDataView } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import {
    getCategoriesDataView,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import translate from "@insite/client-framework/Translate";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden from "@insite/mobius/Hidden";
import Typography from "@insite/mobius/Typography/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    categoriesDataView: getCategoriesDataView(state),
    topLevelCategoryIds: getSubCategoryIds(state, emptyGuid),
    brandsState: getBrandsDataView(state, {}),
});

const mapDispatchToProps = {
    loadCategories,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & PageProps;

export interface GlobalHomePageStyles {
    homePageWrapper?: InjectableCss;
    brandItemsHeader?: InjectableCss;
    brandHeaderContainer?: InjectableCss;
    mainhomeContainers?: InjectableCss;
    mainCategoryItemContainer?: InjectableCss;
    headerHomeContainers?: InjectableCss;
}

export const GlobalHomePageStyles: GlobalHomePageStyles = {
    homePageWrapper: {
        css: css`
            width: 100%;
            border: 1px solid #c2d1d9;
            align-items: center;
            box-sizing: border-box;
        `,
    },
    mainhomeContainers: {
        css: css`
            display: flex;
            min-height: 7rem;
            width: 100%;
            margin-bottom: 1.5625rem;
            flex-direction: column;
        `,
    },

    headerHomeContainers: {
        css: css`
            width: auto;
            align-items: center;
            color: #505d68;
            font-size: 1.2rem;
            font-weight: 700;
            letter-spacing: 0;
            margin-left: .625rem;
            padding-right: 1rem;
        `,
    },
};

const GlobalHomePage: React.FC<Props> = props => {
    useEffect(() => {
        loadCategories();
    }, []);
    const styles = GlobalHomePageStyles;
    return (
        <>
            <Hidden below="lg">
                <StyledWrapper {...styles.homePageWrapper}>
                    {/* Hero container */}
                    <StyledWrapper {...styles.mainhomeContainers}>
                        <StyledWrapper {...styles.headerHomeContainers}>
                            {/* <Typography>{translate("Hero Banner")}</Typography> */}
                        </StyledWrapper>
                        <StyledWrapper {...styles.mainCategoryItemContainer}>
                            <Zone zoneName="BannerCarousel" contentId={props.id} />
                        </StyledWrapper>
                    </StyledWrapper>

                    {/* Shop By Category container */}
                    <StyledWrapper {...styles.mainhomeContainers}>
                        <StyledWrapper {...styles.headerHomeContainers}>
                            <Typography>{translate("Shop By Category")}</Typography>
                        </StyledWrapper>
                    </StyledWrapper>

                    {/* Find your favorite brands container */}
                    <StyledWrapper {...styles.mainhomeContainers}>
                        <StyledWrapper {...styles.headerHomeContainers}>
                            <Typography>{translate("Find Your Favorite Brands")}</Typography>
                        </StyledWrapper>
                    </StyledWrapper>

                    {/* Company container */}
                    <StyledWrapper {...styles.mainhomeContainers}>
                        <StyledWrapper {...styles.headerHomeContainers}>
                            <Typography>{translate("Company at Glance")}</Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </Hidden>
        </>
    );
};

const homePageContainer: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(GlobalHomePage),
    definition: {
        group: "Common",
    },
};

export default homePageContainer;
